module.exports = __webpack_public_path__ + "img/A7.84e64028.png";